import React, { useLayoutEffect, useRef, useState, useEffect } from 'react';
import { SpreadsheetViewer } from './spreadsheet-viewer/client-library/clientLibrary';

export default ({ file, name }) => {
  const svRef = useRef(null);
  const [instancia, setInstancia] = useState(null)

  const toassign = async () => {
   try {
    instancia.configure({
      license: "evaluation",
    });
    instancia.loadWorkbook(file, 0);
   } catch (error) {
     console.error(error)
   }
  }

  const loadDoc = async () => {
    let url  = '';
    
    if(process.env.NODE_ENV === 'development'){
        url = "./spreadsheet-viewer/sv/index.html"
      }else{
        let href = window.location.href
        let splitHref = href.split('#')
        url = splitHref[0] + "spreadsheet-viewer/sv/index.html"
      }


    
    let ins = await SpreadsheetViewer({
        container:  svRef.current,
        assetsUrl: url,
    });
    setInstancia( ins )
}

useLayoutEffect( () => {
  loadDoc()
}, []);

  useEffect(() => {
    if( file && instancia ){
      toassign()
    }
  }, [file,instancia])


  return (<div>
     <a href={file} style={{ display:"block", paddingBottom: '4px' }} download="reporte.xlsx"> Dar click para descargar el archivo </a>
    <div style={{ 
    height: 600,
    width: '100%',
    border: '2px dashed #6c82dc'
  }}  ref={svRef} ></div>
</div>  
  );
};
